
import Keen from 'keen-analysis';

import { getDomainFromUrl } from 'zoomforth_zfutils/url_utils.js';

var keenClientSingleton;
var keenProxiedClientSingleton;


const init = function(options) {
  const projectId = options.projectId || options.keen_project_id;
  const readKey = options.readKey || options.keen_read_key;

  if (!projectId) {
    throw new Error('You must call `init` on `keen-client` appglobal with a `readKey` and a `projectId`');
  }

  // If we dont have a read key but do have a projectId this means that the user does not have access to keen.
  // To avoid breaking the entire UI with an error we just return here and let any subsequent requests return an error instead.
  if(!readKey){
    return;
  }

  keenClientSingleton = new Keen({
    projectId: projectId,
    readKey: readKey,
    protocol: 'https',
    requestType: 'xhr'
  });

  keenProxiedClientSingleton = new Keen({
    projectId: projectId,
    readKey: readKey,
    protocol: 'https',
    host: getDomainFromUrl(k.APPLICATION_URL) + '/api/keen_proxy',
    requestType: 'xhr'
  });
};


const get = function() {
  if (!keenClientSingleton) {
    throw new Error('You must call `init` on `keen-client` appglobal before calling `get`');
  }
  return keenClientSingleton;
};

const getProxied = function() {
  if (!keenProxiedClientSingleton) {
    throw new Error('You must call `init` on `keen-client` appglobal before calling `get`');
  }
  return keenProxiedClientSingleton;
};


export { get, getProxied, init };
export default { get, getProxied, init };
